import { urlLoadProduct } from "../../../urls";
import { Link, useLocation } from "react-router";
import { useCurrentPos } from "../../../hooks/use-current-pos";
import { OptionsGrid } from "../../../components/options-grid";
import { Button } from "@repo/ui/components/button";
import { Title } from "../../../components/title";

function Category() {
  const { club } = useCurrentPos();
  const { state } = useLocation();
  return (
    <div className="flex flex-col items-center justify-center gap-4 w-full py-4 flex-1">
      <Title>Selecciona la categoría del producto</Title>
      <OptionsGrid>
        {club.productCategories.map((category) => (
          <Button key={category.id} variant="pos-outline" size="4xl" asChild>
            <Link
              to={urlLoadProduct("resume")}
              state={{ ...state, categoryId: category.id }}
              viewTransition
            >
              <div>
                <div className="text-4xl">{category.name}</div>
                <div className="text-lg! font-normal text-primary">
                  {category.description}
                </div>
              </div>
            </Link>
          </Button>
        ))}
      </OptionsGrid>
    </div>
  );
}

export const route = {
  path: urlLoadProduct("category"),
  element: <Category />,
  handle: {
    title: "Seleccionar la Categoría del producto",
  },
};
